import React from "react";
import RegistrationForm from "../RegistrationForm";

const Registration = () => {
  const tabTitles = ["2024", "2023", "2022"];

  return (
    <div>
      <img
        src="\baner_novi_beli.jpg"
        alt="Serbian Trophy Logo"
        className="logo"
        style={{
          display: "block",
          margin: "0 auto",
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <RegistrationForm />
    </div>
  );
};

export default Registration;
